import type { WorkspaceCtx } from '@quickreport/workspace';
import { useWorkspace } from '../../lib/workspace';

/** What the workspace functions need to know about who is acting. */
export function useCtx(): WorkspaceCtx & { siteId: string | null } {
  const ws = useWorkspace();
  return {
    orgId: ws.orgId,
    userId: ws.auth.userId,
    memberId: ws.auth.memberId,
    roles: ws.auth.roles,
    deviceId: ws.auth.deviceId,
    siteId: ws.siteId,
  };
}

export const STATUS_LABEL: Record<string, string> = {
  draft: 'Draft',
  awaiting_verification: 'Awaiting verification',
  awaiting_signature: 'Awaiting signature',
  partial: 'Partial',
  final: 'Final',
  amended: 'Being amended',
  revoked: 'Revoked',
};

export const STATUS_TONE: Record<string, 'neutral' | 'brand' | 'flag' | 'ok'> = {
  draft: 'neutral',
  awaiting_verification: 'brand',
  awaiting_signature: 'brand',
  partial: 'brand',
  final: 'ok',
  amended: 'brand',
  revoked: 'flag',
};
